import XLSX from 'xlsx'
import filesaver from 'file-saver'

function s2ab(s) {
  let buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i in s) view[i] = s.charCodeAt(i) & 0xff
  return buf
}

function save(wb, title = '列表') {
  const wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  })
  filesaver.saveAs(
    new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
    title + '.xlsx'
  )
}

/* 将 html talbe 导出到 excel
 * @param [el] HTML DOM Element 对象
 */
export function export_table_to_excel(el, title) {
  if (!el) return

  // El-table 中，使用 fixed 属性会创建两个表格
  const fixedRight = el.querySelector('.el-table__fixed-right')
  const fixed = el.querySelector('.el-table__fixed')
  const table = fixedRight || fixed || el

  // Raw: true | false 是否内容自动格式化
  const wb = XLSX.utils.table_to_book(table, { raw: true })
  save(wb, title)
}

export function exportArrayToTable(el, { data, sheet, title }, options = {}) {
  if (!el) return

  // El-table 中，使用 fixed 属性会创建两个表格
  const fixed = el.querySelector('.el-table__header-wrapper')
  const headers = fixed || el
  const ws = XLSX.utils.table_to_sheet(headers, { raw: true })

  XLSX.utils.sheet_add_json(ws, data, options)

  const wb = {
    SheetNames: [sheet],
    Sheets: { [`${sheet}`]: ws }
  }

  // Raw: true | false 是否内容自动格式化
  save(wb, title)
}
